import store from './../state/index';
import axios from 'axios';
import API from './../API';
export async function checkUserDocumentsTotalStorage() {
  const user = store.getters['auth/getUser'];
  if (user && user._id) {
    const maxStorage = user.account.subscription.plan.features.storage.value;
    const maxDocuments =
      user.account.subscription.plan.features.documents?.value || 0;
    if (maxStorage > 0 || maxDocuments > 0) {
      try {
        const { data: documentsStorage } = await axios.get(API.totalStorage());
        store.commit('documents/setDocumentsTotalStorage', documentsStorage);
      } catch (error) {
        console.log(
          'Something went wrong while retrieving documents total storage: ',
          error
        );
      }
    }
  }
}

export async function toBinaryString(file) {
  // eslint-disable-next-line prettier/prettier
  const promise = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
  return promise;
}
